"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var S = __importStar(require("./LftToast.styles"));
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftLink_1 = __importDefault(require("../LftLink"));
var LftIconButton_1 = __importDefault(require("../LftIconButton"));
var LftProgressBar_1 = __importDefault(require("../LftProgressBar"));
var check_circle_fill_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/check_circle_fill"));
var error_octagon_fill_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/error_octagon_fill"));
var alert_triangle_fill_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/alert_triangle_fill"));
var info_fill_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/info_fill"));
var x_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/x"));
var LftToast = function (_a) {
    var bgColor = _a.bgColor, children = _a.children, message = _a.message, _b = _a.showtime, showtime = _b === void 0 ? 8000 : _b, _c = _a.status, status = _c === void 0 ? 'success' : _c, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, title = _a.title, _e = _a.visible, visible = _e === void 0 ? false : _e, href = _a.href, label = _a.label, target = _a.target, lftClick = _a.lftClick, lftClose = _a.lftClose;
    var _f = (0, react_1.useState)(visible), toastVisible = _f[0], setToastVisible = _f[1];
    var _g = (0, react_1.useState)(100), progress = _g[0], setProgress = _g[1];
    var _handleClose = function (e) {
        var status = !toastVisible;
        setToastVisible(status);
        !!lftClose && lftClose(e);
    };
    (0, react_1.useEffect)(function () {
        if (toastVisible) {
            setProgress(100);
            var progressIntervalId_1 = setInterval(function () {
                setProgress(function (oldProgress) {
                    if (oldProgress <= 0) {
                        clearInterval(progressIntervalId_1);
                        return 0;
                    }
                    return oldProgress - 100 / (showtime / 100);
                });
            }, 100);
            var timer_1 = setTimeout(function (e) {
                if (progress >= 100) {
                    setToastVisible(false);
                }
                !!lftClose && lftClose(e);
            }, showtime);
            return function () {
                clearTimeout(timer_1);
                clearInterval(progressIntervalId_1); // Clean up on unmount
            };
        }
        return;
    }, [toastVisible]);
    (0, react_1.useEffect)(function () {
        setToastVisible(visible);
    }, [visible]);
    var renderSuccess = function () {
        return ((0, jsx_runtime_1.jsx)(S.IconMessage, { children: (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: check_circle_fill_1.default, size: "lg", "aria-hidden": true }) }));
    };
    var renderError = function () {
        return ((0, jsx_runtime_1.jsx)(S.IconMessage, { children: (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: error_octagon_fill_1.default, size: "lg", "aria-hidden": true }) }));
    };
    var renderWarning = function () {
        return ((0, jsx_runtime_1.jsx)(S.IconMessage, { children: (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: alert_triangle_fill_1.default, size: "lg", "aria-hidden": true }) }));
    };
    var renderInfo = function () {
        return ((0, jsx_runtime_1.jsx)(S.IconMessage, { children: (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: info_fill_1.default, size: "lg", "aria-hidden": true }) }));
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!toastVisible && ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ bgColor: bgColor, "data-lift": "lft-toast", role: "alert", status: status, visible: toastVisible }, { children: [(0, jsx_runtime_1.jsxs)(S.Container, { children: [status === 'error' && renderError(), status === 'success' && renderSuccess(), status === 'warning' && renderWarning(), status === 'info' && renderInfo(), (0, jsx_runtime_1.jsxs)(S.Content, { children: [title && ((0, jsx_runtime_1.jsx)("span", __assign({ "aria-labelledby": title, tabIndex: tabIndex }, { children: title }))), message && ((0, jsx_runtime_1.jsx)("p", __assign({ "aria-describedby": message, tabIndex: tabIndex }, { children: message }))), label && (href || lftClick) && ((0, jsx_runtime_1.jsx)(LftLink_1.default, { label: label, href: href, target: target, lftClick: lftClick }))] }), (0, jsx_runtime_1.jsx)(S.Close, { children: (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { icon: x_1.default, size: 'lg', lftClick: _handleClose }) })] }), children, (0, jsx_runtime_1.jsx)(LftProgressBar_1.default, { size: 'md', "aria-hidden": true, value: progress })] }))) }));
};
exports.default = LftToast;
